import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '../components/PageHeader.js';
import { CustomerTabs } from '../components/CustomerTabs.js';
import { Loading, ErrorState } from '../components/States.js';
import { fetchIdentityProfile } from '../api/endpoints.js';

const MATURITY_LABEL: Record<string, string> = {
  invite_only: 'Invite only',
  external_idp: 'External IdP (SSO)',
  scim: 'SCIM provisioned',
};

export function CustomerIdentityPage() {
  const { id: customerOrgId = '' } = useParams();
  const profile = useQuery({
    queryKey: ['identityProfile', customerOrgId],
    queryFn: () => fetchIdentityProfile(customerOrgId),
  });

  return (
    <div className="page">
      <PageHeader title="Identity Maturity" subtitle={`Org ${customerOrgId}`} />
      <CustomerTabs customerOrgId={customerOrgId} />

      {profile.isLoading ? (
        <Loading />
      ) : profile.isError || !profile.data ? (
        <ErrorState error={profile.error} onRetry={() => void profile.refetch()} />
      ) : (
        <section className="card">
          <h3 className="card__title">Profile</h3>
          <dl className="kv">
            <dt>Maturity</dt>
            <dd>
              <span className="badge badge--info">
                {MATURITY_LABEL[profile.data.identity_maturity] ?? profile.data.identity_maturity}
              </span>
            </dd>
            <dt>MFA required</dt>
            <dd>{profile.data.mfa_required ? 'Yes' : 'No'}</dd>
            <dt>Passkeys</dt>
            <dd>{profile.data.passkey_enabled ? 'Enabled' : 'Disabled'}</dd>
            <dt>Login brand</dt>
            <dd>{profile.data.primary_login_brand_key ?? '—'}</dd>
            <dt>Updated</dt>
            <dd>{new Date(profile.data.updated_at).toLocaleString()}</dd>
          </dl>
        </section>
      )}
    </div>
  );
}
